import { useQuery } from '@tanstack/react-query';

import { queryClient } from '../components/queryClient';
import { useFleet } from '../hooks/useFleet';
import { useHasPermission } from '../hooks/useHasPermission';
import { Fleet } from '../interfaces';
import { ReportsService } from '../services/reports.service';

export const useAllReports = () => {
  const fleet = useFleet();
  const queryKey = ['all', fleet.id];
  const hasAccess = useHasPermission('reports:read');
  const queryFn = () => ReportsService.getAllAvailableReports(fleet);

  return useQuery({
    queryKey,
    queryFn,
    enabled: !!fleet.id && hasAccess,
  });
};

export const useReports = () => {
  const fleet = useFleet();
  const queryKey = ['reports', fleet.id];
  const hasAccess = useHasPermission('reports:read');

  const queryFn = () => ReportsService.getAvailableReports(fleet);

  return useQuery({
    queryKey,
    queryFn,
    enabled: !!fleet.id && hasAccess,
  });
};

export const usePermittedReports = () => {
  const fleet = useFleet();
  const queryKey = ['permittedListReports', fleet.id];
  const hasAccess = useHasPermission('reports:read');

  const queryFn = () => ReportsService.getAvailablePermittedReports(fleet);

  return useQuery({
    queryKey,
    queryFn,
    enabled: !!fleet.id && hasAccess,
  });
};

export const refreshReportsQuery = (fleetId: Fleet['id']) => {
  // Make sure we refetch the event in the background, WHEN NEEDED - but display
  // the cached data in the meantime, instantenously
  queryClient.invalidateQueries(['reports', fleetId]);
};

export const refreshPermittedListReports = (fleetId: Fleet['id']) => {
  // Make sure we refetch the event in the background, WHEN NEEDED - but display
  // the cached data in the meantime, instantenously
  queryClient.invalidateQueries(['permittedListReports', fleetId]);
};

export const refreshAllReports = (fleetId: Fleet['id']) => {
  // Make sure we refetch the event in the background, WHEN NEEDED - but display
  // the cached data in the meantime, instantenously
  queryClient.invalidateQueries(['all', fleetId]);
};
